<template>
  <div v-if="connection.monitoring">
    <feather
      type="wifi"
      :class="{
        'connection-red': connection.connectionRating == 'red',
        'connection-yellow': connection.connectionRating == 'yellow',
        'connection-green': connection.connectionRating == 'green',
      }"
      @click.prevent="openConnModal"
    ></feather>
    <b-modal id="connectionModal">
      <div class="connection-rating" v-if="connection.connectionRating">
        <div class="iam-center">
            <feather
              type="wifi"
              :class="{
                'connection-red': connection.connectionRating == 'red',
                'connection-yellow': connection.connectionRating == 'yellow',
                'connection-green': connection.connectionRating == 'green',
              }"
              size="80"
            ></feather>
        </div>
      </div>
      <ul class="connection-info-list" v-if="connection.projectInfo && connection.userInfo">
        <li>
          <div>Verbindungsqualität</div>
          <div>{{ connection.lastPingResult }}ms</div>
        </li>
        <li>
          <div>Benutzer</div>
          <div>{{ connection.userInfo.data.first_name }} {{ connection.userInfo.data.last_name }}</div>
        </li>
        <li v-if="isAdmin">
          <div>PHP API</div>
          <div>{{ connection.projectInfo.data.server.general.php_api }}</div>
        </li>
        <li v-if="isAdmin">
          <div>PHP Version</div>
          <div>{{ connection.projectInfo.data.server.general.php_version }}</div>
        </li>
        <li>
          <div>Directus Version</div>
          <div>{{ connection.projectInfo.data.api.version }}</div>
        </li>
      </ul>
      <template slot="modal-header">
        <h5>Verbindungsinformationen</h5>
      </template>
    </b-modal>
    <b-modal id="connectionRedirectModal">
      <div class="connection-redirect">
        
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "connection",
  data() {
    return {};
  },
  components: {},
  async created() {
    if (!this.connection.monitoring) { await this.$store.dispatch("auth/startConnectionMonitoring");}
  },
  computed: {
    ...mapGetters({
      auth: "auth/isAuth",
      isAdmin: "auth/isAdmin",
      apiSettings: "auth/apiSettings",
      connection: "auth/connection",
    }),
  },
  methods: {
    openConnModal() {
      this.$bvModal.show("connectionModal");
    },
    closeModal() {
      this.$bvModal.hide("connectionModal");
    },
  },
};
</script>

<style>
.connection-info-list li {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}

.connection-red,
.connection-red svg {
  color: red !important;
}

.connection-medium,
.connection-medium svg {
  color: yellow !important;
}

.connection-green,
.connection-green svg {
  color: green !important;
}

.iam-center {
   display:flex!important;
   justify-content:center;
}

.iam-center i {
    display:block;
}
</style>
